import axios from "../../utils/axios";
import { encrypt } from "../utils/ecdh-helper";
import { doRSA, genpbkd } from "../utils/helpers";
import utils from "./cloud-signer-api.utils";

export const cloudSign = async (params, tspUrl) => {
  let {
    tsp_signer_id,
    idp_source,
    idp_level,
    idp_transaction,
    certificateId,
    certificate,
    documents,
    salt,
    password,
    algver,
    algVerNext,
    mimetype,
    token
  } = params;
  
  const authData = {
    tsp_signer_id,
    idp_source,
    idp_level,
    nias: true,
    idp_transaction,
  };

  try {
    const prepSignResponse = await axios.post(`${tspUrl}/prepSign`, {
      authData,
      certificateId,
      documents,
      token,
      algver: algVerNext || algver //ovo se mice
    });
    const { public_encoded_x509, requestId, transid } = prepSignResponse.data;

    const sad = genpbkd({
      salt: salt,
      transid,
      pass: password
    });

     // ovo je privremeno dok se testira
    // kasnije se radi samo ispitivanje algver da li je 2 ili 21
    const encData = algVerNext
      ? await encrypt(sad, public_encoded_x509, algVerNext) 
      : doRSA(sad, public_encoded_x509, algver)

    const signResponse = await axios.post(`${tspUrl}/sign`, {
      authData,
      requestId,
      certData: encData,
      token,
    });
    //	const docs = utils.addSignedHashToDocuments(signResponse.data.documents, preparedDocuments)
    const docs = utils.addSignedHashToDocuments(
      signResponse.data.documents,
      documents
    );
    const responseData = {
      userCertificate: utils.convertBase64ToHex(certificate),
      documents: docs,
    };

    return responseData;
  } catch (error) {
    throw error;
  }
};
